import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { formatDateTime } from '../utils'
import Picture from '../common/Picture'
import firebase from 'firebase/compat/app'
import 'firebase/compat/storage'
import 'firebase/compat/firestore'
import config from '../admin/config.firebase'

export default class Home extends Component {
  constructor(props) {
    super(props)
    this.state = { frontBannerUrl: '', news: [] }
  }

  componentWillMount() {
    if (!firebase.apps.length) {
      firebase.initializeApp(config)
    }
    const storageRef = firebase.storage().ref()
    const firestoreRef = firebase.firestore()

    storageRef
      .child('images/front-banner')
      .getDownloadURL()
      .then((frontBannerUrl) => {
        this.setState({ frontBannerUrl })
      })
      .catch((error) => {})

    firestoreRef
      .collection('news')
      .where('isActive', '==', true)
      .orderBy('createdAt', 'desc')
      .limit(2)
      .get()
      .then((querySnapshot) => {
        let news = []
        querySnapshot.forEach(function (doc) {
          let data = doc.data()
          data.id = doc.id
          news.push(data)
        })
        this.setState({
          news,
        })
      })
  }

  render() {
    return (
      <main id="home">
        {this.renderJubmo()}
        {this.renderBanner()}
        {this.renderAbout()}
        {this.renderNews()}
        {this.renderSponsors()}
      </main>
    )
  }

  renderJubmo() {
    return <div className="masthead" />
  }

  renderBanner() {
    return (
      <div hidden={!this.state.frontBannerUrl} className="bg-blue" id="banner">
        <div className="container">
          <div className="row px-2 py-4 mx-auto">
            <img src={this.state.frontBannerUrl} alt="Front Banner" className="img-fluid mx-auto" />
          </div>
        </div>
      </div>
    )
  }

  renderAbout() {
    return (
      <div className="py-4 bg-white" id="about">
        <div className="container">
          <h3 className="pb-3 mb-4">O godbi</h3>
          <div className="row">
            <div className="col-md-6">
              <p className="text-justify">
                Dolgoletno izročilo godbeništva v Zgornje savinjski dolini sega tja v leta pred prvo svetovno vojno, ko
                so na Lepi Njivi, v Šmihelu in Dol Suhi delovale domače "<i>pleh muzike</i>". Te godbe so delovale
                približno do leta 1932. Leta 1935 je Franc Es sklical godbenike vseh treh godb in sestavil novo godbo v
                Nazarjah. Po 2. svetovni vojni je delo zamrlo do leta 1964, ko je na pobudo Janka Bidra in nekaterih
                godbenikov godba nadaljevala delo v Prosvetnem domu na Rečici ob Savinji. Po daljši prekinitvi delovanja
                se je leta 1976 godbeništvo zopet obudilo in nastala je Delavska godba na pihala Občine Mozirje pod
                vodstvom g. Francija Goljufa, ki se je nato preimenovala v Godbo Zgornje Savinjske doline. Godbo je od
                leta 2000 do leta 2013 umetniško vodil Tomaž Guček, zdaj pa Godbi dirigira prof. Tomaž Podlesnik. Godbo
                Zgornje Savinjske doline sestavlja 68 aktivnih članov, ki prihajajo iz vseh občin Zgornje Savinjske
                doline. Vsako leto pripravijo letni koncert, ki se odvija januarja.
              </p>
            </div>
            <div className="col-md-6">
              <p className="text-justify">
                Godbenicam in godbenikom veliko pomeni, saj je v letnem koncertu vloženega največ truda in odrekanj
                skozi vso sezono. Od leta 2003 godbeniki organizirajo tudi velikonočne koncerte, ki jih izvajajo po
                različnih cerkvah v Zgornji Savinjski dolini. Godba sodeluje na več različnih nastopih po dolini in
                nekateri so postali že tradicionalni. Pustni karneval v Mozirju, velikonočna procesija na Rečici ob
                Savinji, v povorka na Flosarskem balu na Ljubnem ob Savinji, na Lučkem dnevu, ... Godbeniki in godbenice
                se zelo radi udeležujejo nastopov po dolini, saj se na ta način tudi zahvalijo svojim poslušalcem za
                obiske koncertov in vso podporo. Tako letno godba opravi od 25 do 30 nastopov. Godba je članica Zveze
                slovenskih godb in sodeluje z Javnim skladom Republike Slovenije za kulturne dejavnosti, ter se redno
                udeležuje tekmovanj že od leta 1992. Tesno pa sodeluje tudi z Glasbeno šolo Nazarje od koder črpa mlade
                glasbenike, ki bistveno dvigujejo kvaliteto orkestra.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderNews() {
    const { news } = this.state
    if (news.length === 0) {
      return
    }

    return (
      <div className="py-4 bg-light" id="news">
        <div className="container">
          <h3 className="pb-3 mb-4">Aktualne novice</h3>
          <div className="row mb-2">
            {news.map((newsData) => {
              return (
                <div className="col-md-6" key={newsData.id}>
                  <div className="card flex-md-row mb-4 shadow-sm">
                    <div className="card-body d-flex flex-column align-items-start">
                      <h4 className="mb-1">
                        <Link to={`/news/${newsData.id}`} className="text-dark">
                          {newsData.title}
                        </Link>
                      </h4>
                      <div className="mb-2 text-muted">
                        {formatDateTime(newsData.createdAt, { year: 'numeric', month: 'numeric', day: 'numeric' })},
                        objavil {newsData.createdBy.displayName}
                      </div>
                      <p className="card-text mb-auto">{newsData.summary}</p>
                      <Link to={`/news/${newsData.id}`}>Beri naprej</Link>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  renderSponsors() {
    return (
      <div className="py-4 bg-white" id="sponsors">
        <div className="container">
          <h3 className="pb-3 mb-4">Sponzorji</h3>
          <div className="row">
            <figure className="mb-5 col-lg-2 col-md-3 col-sm-6">
              <a href="https://kls.si/" rel="noopener noreferrer" target="_blank">
                <Picture className="mx-auto d-block" image="/images/sponsor-kls" alt="sponsor-kls" />
              </a>
              <figcaption className="mt-2">KLS</figcaption>
            </figure>
            <figure className="mb-5 col-lg-2 col-md-3 col-sm-6">
              <a href="https://www.bsh-group.com" rel="noopener noreferrer" target="_blank">
                <Picture
                  className="mx-auto d-block"
                  style={{ padding: '30px 0' }}
                  image="/images/sponsor-bsh"
                  alt="sponsor-bsh"
                />
              </a>
              <figcaption className="mt-2">BSH</figcaption>
            </figure>
            <figure className="mb-5 col-lg-2 col-md-3 col-sm-6">
              <a href="https://mozirje.si/" rel="noopener noreferrer" target="_blank">
                <Picture
                  className="mx-auto d-block"
                  image="/images/sponsor-obcina-mozirje"
                  alt="sponsor-obcina-mozirje"
                />
              </a>
              <figcaption className="mt-2">Občina Mozirje</figcaption>
            </figure>
            <figure className="mb-5 col-lg-2 col-md-3 col-sm-6">
              <a href="https://www.nazarje.si/" rel="noopener noreferrer" target="_blank">
                <Picture
                  className="mx-auto d-block"
                  image="/images/sponsor-obcina-nazarje"
                  alt="sponsor-obcina-nazarje"
                />
              </a>
              <figcaption className="mt-2">Občina Nazarje</figcaption>
            </figure>
            <figure className="mb-5 col-lg-2 col-md-3 col-sm-6">
              <a href="https://www.obcina-recica.si/" rel="noopener noreferrer" target="_blank">
                <Picture
                  className="mx-auto d-block"
                  image="/images/sponsor-obcina-recica-ob-savinji"
                  alt="sponsor-obcina-recica-ob-savinji"
                />
              </a>
              <figcaption className="mt-2">Občina Rečica ob Savinji</figcaption>
            </figure>
            <figure className="mb-5 col-lg-2 col-md-3 col-sm-6">
              <a href="https://www.ljubno.si/" rel="noopener noreferrer" target="_blank">
                <Picture
                  className="mx-auto d-block"
                  image="/images/sponsor-obcina-ljubno"
                  alt="sponsor-obcina-ljubno"
                />
              </a>
              <figcaption className="mt-2">Občina Ljubno ob Savinji</figcaption>
            </figure>
            <figure className="mb-5 col-lg-2 col-md-3 col-sm-6">
              <a href="https://www.luce.si/" rel="noopener noreferrer" target="_blank">
                <Picture className="mx-auto d-block" image="/images/sponsor-obcina-luce" alt="sponsor-obcina-luce" />
              </a>
              <figcaption className="mt-2">Občina Luče</figcaption>
            </figure>
            <figure className="mb-5 col-lg-2 col-md-3 col-sm-6">
              <a href="https://www.gornji-grad.si/" rel="noopener noreferrer" target="_blank">
                <Picture
                  className="mx-auto d-block"
                  image="/images/sponsor-obcina-gornji-grad"
                  alt="sponsor-obcina-gornji-grad"
                />
              </a>
              <figcaption className="mt-2">Občina Gornji Grad</figcaption>
            </figure>
            <figure className="mb-5 col-lg-2 col-md-3 col-sm-6">
              <a href="https://www.solcava.si/" rel="noopener noreferrer" target="_blank">
                <Picture
                  className="mx-auto d-block"
                  image="/images/sponsor-obcina-solcava"
                  alt="sponsor-obcina-solcava"
                />
              </a>
              <figcaption className="mt-2">Občina Solčava</figcaption>
            </figure>
          </div>
        </div>
      </div>
    )
  }
}
